import { useState } from 'react'

import Button from '../../../Button'
import { UploadImageModal, useUploadImageModal } from '../../../UploadImage'
import { Container } from '../../Container'
import {
  PREVIEW_INTERACTIVE,
  PREVIEW_PLACEHOLDER_IMAGE,
} from '../UploadImageUsage.constants'
import { buildEntityPayload, getUpload } from '../UploadImageUsage.utils'

import * as styles from './UploadImageDemo.module.css'

function UploadImageDemo({
  cropShape,
  documentType,
  initialImageUrl,
  parent,
  previewState,
  titleKey,
  uploadMode,
  withRotate,
  withUndo,
}) {
  const [result, setResult] = useState(null)

  const isPreview = previewState !== PREVIEW_INTERACTIVE

  // Step-2 stand-in: a real opener hook would call its update API here.
  function handleSave({ document, documentId }) {
    setResult({
      payload: buildEntityPayload({ cropShape, documentId }),
      preview: document?.preview ?? null,
    })

    return Promise.resolve()
  }

  const { fileInputProps, handleOpen, isOpen, modalProps } =
    useUploadImageModal({
      cropShape,
      documentType: documentType || undefined,
      initialImageUrl: isPreview
        ? initialImageUrl || PREVIEW_PLACEHOLDER_IMAGE
        : initialImageUrl || null,
      parent: parent || undefined,
      qaName: 'uploadImageDemo',
      titleKey,
      withRotate,
      withUndo,
      onSave: handleSave,
      onUpload: getUpload(uploadMode),
    })

  return (
    <Container label='Upload image'>
      <Button.Contained
        qaName='openUploadImage'
        text={initialImageUrl ? 'Edit image' : 'Add image'}
        onClick={handleOpen}
      />

      <input {...fileInputProps} />

      {result ? (
        <div className={styles.result}>
          {result.preview ? (
            <img alt='' className={styles.preview} src={result.preview} />
          ) : null}
          <pre className={styles.payload}>
            {JSON.stringify(result.payload, null, 2)}
          </pre>
        </div>
      ) : null}

      {isOpen ? (
        <UploadImageModal
          {...modalProps}
          previewState={isPreview ? previewState : undefined}
        />
      ) : null}
    </Container>
  )
}

export default UploadImageDemo
